<template>
    <div class="wait-dialog" v-if="isShowDialog">
        <div class="course-info">
            <div class="title">{{ classInfo ? classInfo.title : '' }}</div>
            <div class="count-down" v-if="countDownText">
                距离直播开始还有
                <span>{{ countDownText }}</span
                ><br />
                请耐心等待哦～
            </div>
            <div class="count-down" v-else style="font-size: 14px; color: #999">讲师正在赶来的路上</div>
        </div>
    </div>
</template>
<script>
const store = BJY.store
let _interval = null
export default {
    data() {
        return {
            isShowDialog: false,
            countDownText: '',
            classInfo: null,
        }
    },
    created() {
        // 判断是否已经开始上课
        // 没有上课，查看是否需要倒计时
        // eventEmitter.one(eventEmitter.LOADING_PANEL_END, () => {
        //     this.classInfo = store.get('class')
        // })

        store.watch(
            'class.started',
            (started) => {
                if (started === true) {
                    this.updateStatus(false, '')
                } else {
                    const _now = Date.now()
                    this.classInfo = store.get('class')
                    if (this.classInfo) {
                        if (_now < this.classInfo.endTime) {
                            this.onStartCountDown()
                        } else {
                            this.updateStatus(false, '')
                        }
                    }
                }
            },
            true
        )
    },
    methods: {
        updateStatus(state, text) {
            this.isShowDialog = state
            this.countDownText = text
            if (!state) {
                clearInterval(_interval)
            }
        },
        onStartCountDown() {
            // 使用示例
            this.countdown(this.classInfo.startTime, (res) => {
                if (res.status) {
                    const { days, hours, minutes, seconds } = res.result
                    let _str = ''
                    if (days > 0) {
                        _str += `${days}天`
                    }
                    if (hours > 0) {
                        _str += `${hours}小时`
                    }
                    if (minutes > 0) {
                        _str += `${minutes}分钟`
                    }
                    if (seconds > 0) {
                        _str += `${seconds}秒`
                    }
                    this.updateStatus(true, _str)
                } else {
                    this.updateStatus(true, '')
                }
            })
        },
        countdown(startTime, callback) {
            _interval = setInterval(() => {
                const now = new Date().getTime()
                const distance = startTime - now

                let status = true
                let result

                if (distance < 0) {
                    clearInterval(_interval)
                    status = false
                    result = {
                        days: 0,
                        hours: 0,
                        minutes: 0,
                        seconds: 0,
                    }
                } else {
                    const days = Math.floor(distance / (1000 * 60 * 60 * 24))
                    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
                    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
                    const seconds = Math.floor((distance % (1000 * 60)) / 1000)

                    result = {
                        days,
                        hours,
                        minutes,
                        seconds,
                    }
                }

                callback({ status, result })
            }, 300)
        },
    },
}
</script>
<style lang="scss" scoped>
.wait-dialog {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000, $alpha: 0.9);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    .course-info {
        width: 360px;
        background: #fff;
        border-radius: 6px;
        .title {
            font-size: 20px;
            max-height: 70px;
            line-height: 35px;
            overflow: hidden;
            text-align: center;
            color: #333;
            width: 90%;
            margin: 20px auto;
        }
        .nickname {
            font-size: 16px;
            line-height: 40px;
            text-align: center;
            color: #999;
        }
        .count-down {
            span {
                color: #20c6a7;
            }
            font-size: 16px;
            line-height: 40px;
            text-align: center;
            padding-bottom: 12px;
        }
    }
}
</style>
